import { render, staticRenderFns } from "./WrNotaryCertificate.vue?vue&type=template&id=70011b94&"
import script from "./WrNotaryCertificate.vue?vue&type=script&lang=js&"
export * from "./WrNotaryCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports